$(document).on("turbolinks:load", function () {

  if ($('.message-thread-list').is('*')) {
    $('body').on('click', '.message-thread-list a.js-message-link', function(e){
      e.preventDefault();

      var thread_id = $(this).data('thread-id');
      var source = $(this).data('source');

      $('.message-thread-list li').removeClass('active');
      $(this).parent('li').addClass('active');

      $('.js-message-threads .js-message-thread').addClass('d-none');
      $('#js-spinner').removeClass('d-none');

      // Embedded (tabbed) panels raise the reading pane fullscreen when they're in
      // the single-column layout (js-messages-narrow, set by panel width); the full
      // inbox keeps its own sm (575px) viewport breakpoint.
      var $msgContainer = $('#messages-container');
      var raiseThread = $msgContainer.closest('.tab-pane').length
        ? $msgContainer.hasClass('js-messages-narrow')
        : $(window).width() < 575;
      if (raiseThread) {
        $('.js-message-threads').addClass('rise-for-mobile');
      }

      loadMessage(thread_id, source);
    });

    $('body').on('click', '#paginate-inbox a, #paginate-outbox a, #paginate-archived a', function(e){
      var url = $(this).attr('href');

      var isThreadListPagination = url &&
        url !== '#' &&
        (url.indexOf('/business/message_threads') === 0 || url.split('?')[0] === window.location.pathname);

      if (!isThreadListPagination) {
        return;
      }

      e.preventDefault();

      if ($(this).closest('li').hasClass('disabled') || $(this).closest('li').hasClass('active')) {
        return;
      }

      var list = $('#' + $(this).closest('#paginate-inbox, #paginate-outbox, #paginate-archived').attr('id').replace('paginate-', ''));
      var spinner = $('<li class="d-flex align-items-center justify-content-center p-4"></li>').append($('#js-spinner i').first().clone());

      list.css('min-height', list.height() + 'px').html(spinner);

      $.ajax({
        url: url,
        type: 'GET',
        dataType: 'script',
        beforeSend: function(xhr){
          xhr.setRequestHeader('X-CSRF-Token', localStorage.getItem("bp-x-csrf-token"));
        },
        complete: function(){
          list.css('min-height', '');
        },
        error: function(){
          window.location = url;
        }
      });
    });

    $('body').on('click', '.js-unread-btn', function(){
      if ($(this).data('state') == 'unread') {
        updateReadAt($(this).data('thread'));
      } else {
        markUnread(this);
      }
    });

    $('body').on('click', '.js-important-btn', function(){
      toggleImportant($(this).data('thread'));
    })

    $('body').on('mouseenter mouseleave', '.js-important-btn', function(){
      toggleImportantIcon(this);
    })

    $('body').on('click', '.js-exit-mail', function(){
      $('.js-message-threads').removeClass('rise-for-mobile');
    });

    changeMailbox();
    loadFirstMessage();
    requestAnimationFrame(resizeMessagesContainer);
    setTimeout(resizeMessagesContainer, 300);
    $(window).off('resize.messagesContainer').on('resize.messagesContainer', resizeMessagesContainer);

    $('body').off('shown.bs.tab.messagesContainer').on('shown.bs.tab.messagesContainer', 'a[data-toggle="tab"]', function(){
      loadFirstMessage();
      resizeMessagesContainer();
      // The group-booking messages tab isn't active on load, so its first accurate
      // measurement can only happen once it's shown and laid out.
      setTimeout(resizeMessagesContainer, 60);
    });
  }

  changeMessageType();
});

// When the message panel is embedded in a tab (client/booking show pages) it has no
// full-height ancestor to flex against. The stylesheet bounds it with
// `height: calc(100dvh - var(--msg-top))`; here we publish --msg-top = the panel's
// document-relative distance from the top, which is scroll-STABLE, so the panel
// reaches the viewport bottom (pagination + reply pinned there) without a scroll
// handler that could capture a stale/too-small value and over-grow the panel.
function resizeMessagesContainer() {
  var container = document.getElementById('messages-container');

  if (!container) {
    return;
  }

  var $container = $(container);
  if (!$container.is(':visible')) {
    return;
  }

  // Embedded panels (in a tab) collapse to a single column based on the PANEL's own
  // width, not the viewport, so the full-width group-booking panel and the
  // column-embedded client / single-booking panels collapse at the same content width
  // (780px = the client panel's width at its collapse point: 825px @1200 → 729px @1199).
  // The full inbox keeps its own Bootstrap col + 575px breakpoint, so skip it there.
  if (container.closest('.tab-pane')) {
    var width = container.getBoundingClientRect().width;
    $container.toggleClass('js-messages-narrow', width > 0 && width < 780);
  }

  var offsetTop = $container.offset().top;
  if (offsetTop > 50) {
    container.style.setProperty('--msg-top', Math.round(offsetTop) + 'px');
  }
}


function loadMessage(thread_id, source) {
  if (thread_id) {
    $.ajax({
      url: "/business/message_threads/load_message_thread.js",
      type: "GET",
      beforeSend: function(xhr){
        xhr.setRequestHeader('X-CSRF-Token', localStorage.getItem("bp-x-csrf-token"));
      },
      data: { message_thread_id: thread_id, source: source },
      dataType: 'script',
      success: function(){
        $('[data-toggle="tooltip"]').tooltip();

        thread = $('#thread_'+thread_id+' .message-thread');
        thread.scrollTop(thread[0].scrollHeight);
        updateReadAt(thread_id);
      }
    });
  }
}

function loadFirstMessage() {
  // Load the first message by default
  if($('#js-thread-target').is(':empty') || $('#js-thread-target .js-empty-box').is(':visible')) {
    first_link = $('a.js-message-link:visible:first');

    if (!first_link.length) {
      return;
    }

    first_link.parent('li').addClass('active');

    loadMessage(first_link.data('thread-id'), first_link.data('source'));
  }
}

function updateReadAt(thread_id) {
  if (thread_id) {
    $.ajax({
      url: "/business/message_threads/update_read_at",
      type: "POST",
      beforeSend: function(xhr){
        xhr.setRequestHeader('X-CSRF-Token', localStorage.getItem("bp-x-csrf-token"));
      },
      data: { message_thread_id: thread_id },
      dataType: 'json',
      success: (response) => {
        var unreadButton = $('button.js-unread-btn[data-thread="'+thread_id+'"]')
        var unreadCount = response.unread_count;

        unreadButton.data('state', 'read');
        var icon = unreadButton.find('i');
        icon.attr('data-original-title', 'Mark unread');
        icon.removeClass('fa-mailbox');
        icon.addClass('fa-mailbox-flag-up');
        icon.tooltip();

        var $threadItem = $('.js-message-link[data-thread-id="' + thread_id + '"]').closest('li');
        var wasUnread = $threadItem.hasClass('unread');
        $threadItem.removeClass('unread');
        $('#js-thread-'+thread_id).removeClass('unread');

        if (wasUnread) {
          updateMessagesTabBadge(-1);
        }

        if ( unreadCount > 0) {
          $('.unread-messages-badge span').html(unreadCount);
        } else {
          $('.unread-messages-badge').remove();
        }
      }
    });

  }
}

// Keep the Messages tab badge (client/booking show pages) in sync as threads are
// read (-1) or marked unread (+1). The current unread count lives on the badge's
// data-unread attribute so it stays consistent across both actions. When the unread
// count reaches 0 the badge falls back to the gray total-thread count (data-total),
// matching the server-rendered view.
function updateMessagesTabBadge(delta) {
  var $badge = $('.js-messages-tab-badge');
  if (!$badge.length) return;

  var unread = Math.max(0, (parseInt($badge.attr('data-unread'), 10) || 0) + delta);
  var total = parseInt($badge.attr('data-total'), 10) || 0;
  $badge.attr('data-unread', unread);

  if (unread > 0) {
    $badge.html('<span class="badge badge-pill badge-danger">' + unread + '</span>');
  } else if (total > 0) {
    $badge.html('<span class="badge badge-pill badge-secondary">' + total + '</span>');
  } else {
    $badge.html('');
  }
}

function markUnread(button) {
  var thread_id = $(button).data('thread');

  $.ajax({
    url: "/business/message_threads/mark_thread_unread",
    type: "POST",
    beforeSend: function(xhr){
      xhr.setRequestHeader('X-CSRF-Token', localStorage.getItem("bp-x-csrf-token"));
    },
    data: { message_thread_id: thread_id },
    dataType: 'json',
    success: function () {

      $(button).data('state', 'unread');

      var icon = $(button).find('i');
      icon.attr('data-original-title', 'Mark read');
      icon.removeClass('fa-mailbox-flag-up');
      icon.addClass('fa-mailbox');
      icon.tooltip();

      var $threadItem = $('.js-message-link[data-thread-id="' + thread_id + '"]').closest('li');
      if (!$threadItem.hasClass('unread')) {
        updateMessagesTabBadge(1);
      }
      $threadItem.addClass('unread');
    }
  });
}

function toggleImportant(thread_id) {
  if (thread_id) {
    $.ajax({
      url: "/business/message_threads/toggle_important.js",
      type: "POST",
      beforeSend: function(xhr){
        xhr.setRequestHeader('X-CSRF-Token', localStorage.getItem("bp-x-csrf-token"));
      },
      data: { message_thread_id: thread_id },
      dataType: 'json',
      success: function () {
        var important_button = $('button.js-important-btn[data-thread="'+thread_id+'"]');
        var important_icon = $('.js-important-icon[data-thread="'+thread_id+'"]');
        var message_type_icons = $('.js-message-type-icons[data-thread="'+thread_id+'"]');

        if (important_button.data('important')) {
          important_button.data('important', false);
          important_icon.addClass('d-none');
          message_type_icons.removeClass('d-none');
          important_button.find('i').removeClass('text-success');
          important_button.find('i').addClass('text-muted');
        } else {
          important_button.data('important', true);
          message_type_icons.addClass('d-none');
          important_icon.removeClass('d-none');
          important_button.find('i').removeClass('text-muted');
          important_button.find('i').addClass('text-success');
        }
      }
    });
  }
}

function toggleImportantIcon(icon) {
  var fa_icon = $(icon).find('i');
  if (fa_icon.hasClass('far')) {
    fa_icon.removeClass('far');
    fa_icon.addClass('fas');
  } else {
    fa_icon.removeClass('fas');
    fa_icon.addClass('far');
  }
}

function changeMailbox() {
  $('.js-mailbox-button').on('click', function(){
    var type = $(this).data('mailbox');

    if (type == 'inbox') {
      var alternates = ['outbox', 'archived'];
    } else if (type == 'outbox') {
      var alternates = ['inbox', 'archived'];
    } else {
      var alternates = ['inbox', 'outbox'];
    }

    $('.js-mailbox-button').removeClass('active');
    $(this).addClass('active');
    $('.message-thread-list li').removeClass('active');

    alternates.forEach((alternate) => {
      $('#'+alternate).addClass('d-none');
      $('#paginate-'+alternate).addClass('d-none');
    })

    $('#js-thread-target').empty();
    $('#'+type).removeClass('d-none');
    $('#paginate-'+type).removeClass('d-none');

    loadFirstMessage();
  });
}

function changeMessageType() {

  $('body').on('click', '.js-sms-button', function (event) {
    $('#sms-warning').removeClass('d-none');
    $('.js-email-inputs').fadeOut('fast', function(){
      $('.js-email-inputs input[type=text], .js-email-inputs textarea').prop("disabled", true);
      $('.js-sms-inputs input, .js-sms-inputs textarea').prop("disabled", false);
      $('.js-sms-inputs').fadeIn('fast');
    });
  });

  $('body').on('click', '.js-email-button', function (event) {
    $('#sms-warning').addClass('d-none');
    $('.js-sms-inputs').fadeOut('fast', function(){
      $('.js-email-inputs').fadeIn('fast');

      $('.js-sms-inputs input, .js-sms-inputs textarea').prop("disabled", true);
      $('.js-email-inputs input[type=text], .js-email-inputs textarea').prop("disabled", false);
    });
  });

  $('body').on('submit', '.js-message-form-validation', function(event){
    var trixEditor = $(this).find('trix-editor:visible');
    var smsEditor = $(this).find('.js-sms-inputs textarea:visible');
    var submitBtn = $(this).find('[type=submit]');

    if(trixEditor != undefined && trixEditor.length > 0) {
      if(trixEditor.val() == '') {
        trixEditor.prop('style', 'border: 1px solid red;');

        setTimeout(function() {
          submitBtn.prop('disabled', false);
          submitBtn.html('<i class="fas fa-paper-plane mr-2"></i> Send Message');
        }, 25);

        event.preventDefault();
      } else {
        trixEditor.prop('style', '');
      }
    }else if (smsEditor != undefined && smsEditor.length > 0) {
     if(smsEditor.val() == '') {
        smsEditor.prop('style', 'border: 1px solid red;');

        setTimeout(function() {
          submitBtn.prop('disabled', false);
          submitBtn.html('<i class="fas fa-paper-plane mr-2"></i> Send Message');
        }, 25);

        event.preventDefault();
      } else {
        smsEditor.prop('style', '');
      }
    }
  })
}
